<script>
    export default {
        name: 'design-2021-analytics-overview-component',
        props: {
            schoolsIn: {
                type: Array
            },
            untaggedGroupsIn: {
                type: Array
            },
            analyticsTagsIn: {
                type: Array
            }
        }
    };
</script>

<template>
    <b-tabs class="apprentice-tab">
        <b-tab :title="$t('admin.schools')">
            <design-2021-analytics-index-component
                :schools-in="schoolsIn">
            </design-2021-analytics-index-component>
        </b-tab>
        <b-tab :title="$t('analytics.untagged_groups')">
            <design-2021-analytics-untagged-groups-component
                :untagged-groups-in="untaggedGroupsIn">
            </design-2021-analytics-untagged-groups-component>
        </b-tab>
        <b-tab :title="$t('common.tags')">
            <design-2021-analytics-tag-management-component
                :analytics-tags-in="analyticsTagsIn">
            </design-2021-analytics-tag-management-component>
        </b-tab>
    </b-tabs>
</template>

<style scoped lang="scss">

</style>